import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { ChevronDownIcon } from "@twilio-paste/icons/esm/ChevronDownIcon";
import { useDispatch, useSelector } from "react-redux";

import { changeExpandedStatus } from "../store/actions/genericActions";
import { AppState } from "../store/definitions";
import { BRAND } from "../brands";
import { containerStyles, titleStyles, minimizeButtonStyles } from "./styles/Header.styles";

export const Header = ({ customTitle }: { customTitle?: string }) => {
    const dispatch = useDispatch();
    // Título do cabeçalho: prop (interno) > config do dashboard (runtime) > default de build da marca.
    const configTitle = useSelector((state: AppState) => state.config?.headerTitle);
    const title = customTitle || configTitle?.trim() || BRAND.headerTitle;

    return (
        <Box
            as="header"
            data-test="main-header"
            style={{ borderTopLeftRadius: "20px", borderTopRightRadius: "20px" }}
            {...containerStyles}
        >
            <Text as="h2" {...titleStyles}>
                {title}
            </Text>
            <Box
                as="button"
                data-test="minimize-button"
                onClick={() => dispatch(changeExpandedStatus({ expanded: false }))}
                {...minimizeButtonStyles}
            >
                <ChevronDownIcon decorative={false} title="Minimizar conversa" size="sizeIcon60" />
            </Box>
        </Box>
    );
};
